import React from 'react';
function AboutSection() {  return (
  <section id="about">
    <div className="wrap about reveal">
      <div className="about-photo">
        <div className="frame">
          <img
            className=""
            src="/image/school.jpeg"
            alt="Comprehensive High School"
          />
        </div>
        <div className="dots"></div>
      </div>
      <div className="about-copy">
        <div className="eyebrow">{'About Us'}</div>
        <h2>{'Building a Strong Foundation for a Bright Tomorrow'}</h2>
        <p>
          {
            'Comprehensive High School is committed to providing a nurturing environment that fosters curiosity, creativity and critical thinking. Our balanced approach to academics and co-curricular life helps students discover their passions and grow into confident, compassionate global citizens.'
          }
        </p>
        <p>
          {
            "From our earliest years' classrooms to our senior leadership programs, every stage of a Comprehensive High School education is designed around one belief: children rise to the standard they're trusted with."
          }
        </p>
        <a
          href="#academics"
          className="btn ghost-navy"
          style={{marginTop: '22px'}}
        >
          {'Learn More About Us\n        '}
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.2"
          >
            <path d="M5 12h14M13 6l6 6-6 6"></path>
          </svg>
        </a>
      </div>
      <div className="about-stats">
        <div className="stat">
          <div className="ic">
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="#3FA9E0"
              strokeWidth="2"
            >
              <circle cx="9" cy="8" r="3"></circle>
              <path d="M2 20c0-3 3-5 7-5s7 2 7 5"></path>
              <circle cx="18" cy="9" r="2.4"></circle>
              <path d="M15 20c.3-2 2-3.4 5-3.4"></path>
            </svg>
          </div>
          <div>
            <b>{'300+'}</b>
            <span>{'Students'}</span>
          </div>
        </div>
        <div className="stat">
          <div className="ic">
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="#3FA9E0"
              strokeWidth="2"
            >
              <path d="M22 10L12 4 2 10l10 6 10-6z"></path>
              <path d="M6 12v5c3 2 9 2 12 0v-5"></path>
            </svg>
          </div>
          <div>
            <b>{'20+'}</b>
            <span>{'Faculty Members'}</span>
          </div>
        </div>
        <div className="stat">
          <div className="ic">
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="#3FA9E0"
              strokeWidth="2"
            >
              <path d="M12 3l7 3v6c0 5-3 8-7 9-4-1-7-4-7-9V6l7-3z"></path>
            </svg>
          </div>
          <div>
            <b>{'25+'}</b>
            <span>{'Years of Excellence'}</span>
          </div>
        </div>
      </div>
    </div>
  </section>
);
}

export default AboutSection;
